<template lang="pug">
    .component-card-4
        .row
            .columns.shrink.align-self-middle(v-if="showBullets")
                slot(name="actionBullets")
            .columns
                .row
                    .columns.n1
                        slot(name="n1")
                    .columns.n2
                        slot(name="n2")
                    .columns.n3
                        slot(name="n3")
                    .columns.n4
                        slot(name="n4")
            .columns.shrink.align-self-middle(v-if="showAction")
                slot(name="actionPage")
</template>
<script type="text/babel">
    export default{
        name: "Card4",
        components: {
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {
            actionClicked(){
                this.$emit('actionClicked')
            },
            bulletsClicked(){
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// Card4.vue?5c92b996